export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";